export default __webpack_public_path__ + "static/media/new_01.fabd9805.jpg";